





























import { Component, Vue } from "vue-property-decorator";

@Component
export default class Navbar extends Vue {
  private currentPage = this.$route.name;
  private active = false;

  mounted() {

  }
  
  clickDropdown() {
    this.$router.push('/models');
  }

  showDropdown() {
    this.$refs.dropdown.visible = true;
  }

  hideDropdown() {
    this.$refs.dropdown.visible = false;
  }

}
